<script>
export default {
    name: "mine",
    data() {
        return {
            menu: [
                { text: '用户信息', url: '/mine/userinfo' },
                { text: '修改密码', url: '/mine/updataPwd' },
                { text: '我的订单', url: '/mine/order' },
                { text: '我的会员', url: '/vip' },
                { text: '我的发票', url: '/mine/invoice' },
                { text: '收货地址', url: '/mine/address' },
                { text: '退款管理', url: '/mine/refund' },
            ]
        };
    },
    computed: {},
    components: {
        
    },
    mounted() {},
    destroyed() {},
    watch: {},
    methods: {
        // 登出
        logout() {
            if (confirm('是否确认登出？')) { 
                localStorage.removeItem('token');
                this.$router.push('/');
            }
        },
    },
};
</script>

<template>
    <div class="mine">
        <div class="banner layout_bg"></div>
        <div class="wrapper layout_main flex">
            <div class="menu">
                <div class="item" v-for="(item, index) in menu" :key="index">
                    <router-link :to="item.url">{{ item.text }}</router-link>
                </div>
                <div class="item">
                    <a href="javascript:;" @click="logout">登出</a>
                </div>
            </div>
            <div class="content">
                <router-view></router-view>
            </div>
        </div>
    </div>
</template>

<style scoped lang="scss">
.mine{
    .banner{
        width: 100%;
        height: 4.8rem;
        background-color: rgba($color: #000000, $alpha: .5);
    }
    .wrapper{
        padding: .4rem 0;
    }
    .menu{
        width: 2.3rem;
        flex-shrink: 0;
        padding-left: .45rem;
        .item{
            font-size: .16rem;
            color: #999;
            margin-bottom: .2rem;
            a{
                &:hover,
                &.active{
                    color: var(--font_color);
                    border-bottom: 1px solid var(--font_color);
                }
            }
        }
    }
    .content{
        flex: 1;
    }
}
</style>
<style lang="scss">
.mine{
    .title{
        font-size: .2rem;
        font-weight: bold;
        margin-bottom: .3rem;
    }
    .btn_bottom_group{
        gap: .4rem;
        padding-top: .8rem;
    }
    .btn_submit{
        width: .9rem;
        height: .4rem;
        border-radius: 0.1rem;
        background: #f0f0f0;
        font-size: .16rem;
        cursor: pointer;
        // box-shadow: 0 0 .07rem rgba($color: #000000, $alpha: .3);
        filter: drop-shadow(0 .02rem .01rem rgba($color: #000000, $alpha: .3)) drop-shadow(0 0 .02rem rgba($color: #000000, $alpha: .3));
    }
    .tabs{
        display: flex;
        font-size: .16rem;
        gap: .3rem;
        color: #999;
        margin-bottom: .2rem;
        .item{
            cursor: pointer;
            &:hover,
            &.active{
                color: var(--font_color);
            }
        }
    }
    .loading_wrap,
    .no_more{
        padding: .8rem 0;
    }
    .no_more{
        a{
            color: var(--font_color);
            border-bottom: 1px solid var(--font_color);
        }
    }
    .order_list{
        .tr{
            display: flex;
            .td{
                padding: 0 .1rem;
            }
        }
        .item{
            font-size: .12rem;
            border-bottom: 1px solid #ebebeb;
            padding: .2rem 0;
            &:last-child,
            &.thead{
                border-bottom: none;
            }
            &.thead{
                background: #f7f7f7;
                border-radius: .1rem .1rem 0 0;
                text-align: center;
                font-size: .14rem;
            }
            .top{
                padding: 0 .1rem;
                margin-bottom: .2rem;
                gap: .2rem;
            }
            .price2{
                text-align: center;
            }
            .btn_group{
                display: flex;
                flex-direction: column;
                align-items: center;
                gap: .1rem;
                .btn{
                    // width: .7rem;
                    height: .3rem;
                    border-radius: .05rem;
                    cursor: pointer;
                    position: relative;
                    padding: 0 .1rem;
                    &:hover{
                        background: #f0f0f0;
                    }
                    &.disabled{
                        cursor: auto;
                    }
                    .text{
                        user-select: none;
                    }
                    .logistics{
                        position: absolute;
                        top: 100%;
                        right: 0;
                        white-space: nowrap;
                        // border: 1px solid #f0f0f0;
                        padding: .06rem .2rem;
                        border-radius: .05rem;
                        gap: .2rem;
                        box-shadow: 0 0 .04rem rgba($color: #000000, $alpha: .2);
                    }
                }
            }
            .info{
                display: flex;
                .cover{
                    width: .9rem;
                    height: 1.1rem;
                    border: 1px solid var(--font_color);
                }
                .wrapper{
                    flex: 1;
                    padding: 0 .2rem;
                    display: flex;
                    flex-direction: column;
                    justify-content: space-around;
                    .name{
                        font-size: .16rem;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        display: -webkit-box;
                        -webkit-line-clamp: 2;
                        /*! autoprefixer: off */
                        -webkit-box-orient: vertical;
                        /* autoprefixer: on */
                    }
                    .info_btn_group{
                        display: flex;
                        gap: .1rem;
                        .btn{
                            width: .7rem;
                            height: .2rem;
                            border: 1px solid #ccc;
                            border-radius: .03rem;
                            cursor: pointer;
                        }
                    }
                }
            }
        }
    }
    .form{
        display: flex;
        gap: .2rem;
        flex-direction: column;
        &.row{
            flex-wrap: wrap;
            flex-direction: row;
            width: auto;
            &.edit{
                .item{
                    &:nth-of-type(2n){
                        justify-content: flex-end;
                    }
                }
            }
        }
        .item{
            display: flex;
            // align-items: center;
            font-size: .16rem;
            gap: 0 .1rem;
            .name{
                flex-shrink: 0;
                width: 1rem;
                font-size: .16rem;
                line-height: .4rem;
            }
            .btn_code{
                height: .4rem;
                border-radius: .05rem;
                border: 1px solid var(--font_color);
                width: 1.1rem;
                cursor: pointer;
            }
            textarea{
                flex: 1;
                border: 1px solid var(--font_color);
                border-radius: .05rem;
                height: 2rem;
                padding: .1rem;
                font-size: .16rem;
                resize: none;
            }
            input{
                &[type=text],
                &[type=password],
                &[type=email],
                &[type=tel]{
                    flex: 1;
                    border: 1px solid var(--font_color);
                    border-radius: .05rem;
                    height: .4rem;
                    padding: 0 .1rem;
                    font-size: .16rem;
                    &.code{
                        width: 2rem;
                    }
                }
                &[type=radio],
                &[type=checkbox]{
                    appearance: none;
                    width: .16rem;
                    height: .16rem;
                    border: 1px solid var(--font_color);
                    border-radius: 50%;
                    position: relative;
                    cursor: pointer;
                    &:checked{
                        &::after{
                            content: "";
                            position: absolute;
                            top: 50%;
                            left: 50%;
                            transform: translate(-50%, -50%);
                            width: 60%;
                            height: 60%;
                            border-radius: 50%;
                            background: var(--font_color);
                        }
                    }
                }
            }
            .radio_group{
                height: .4rem;
                gap: .2rem;
                font-size: .16rem;
                &,
                .radio{
                    display: flex;
                    align-items: center;
                }
                .radio{
                    gap: .05rem;
                    line-height: 1;
                    cursor: pointer;
                }
            }
            .select{
                flex: 1;
                width: auto;
            }
            .btn{
                height: .4rem;
                padding: 0 .2rem;
                font-size: .16rem;
                border: 1px solid var(--font_color);
                border-radius: .05rem;
                cursor: pointer;
                line-height: 1;
                display: flex;
                justify-content: center;
                align-items: center;
                &.disabled{
                    color: #fff;
                    background: #666;
                    border-color: #666;
                    cursor: auto;
                }
            }
        }
    }
    .popup{
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: rgba($color: #000000, $alpha: .7);
        z-index: 999;
        .in{
            width: 8.6rem;
            background: #fff;
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
        }
        .btn_group{
            gap: .15rem;
        }
        .btn{
            height: .3rem;
            padding: 0 .1rem;
            font-size: .16rem;
            border: 1px solid var(--font_color);
            border-radius: .05rem;
            cursor: pointer;
            line-height: 1;
            display: flex;
            justify-content: center;
            align-items: center;
            &.disabled{
                color: #fff;
                background: #666;
                border-color: #666;
                cursor: auto;
            }
        }
    }
}
</style>
